// src/utils/session.js - client-side view of the login token (audit FL-25).
//
// The backend issues a 24-hour JWT. A long upload or a long form started shortly
// before the token expires fails with 401 at the very end, so the UI checks the
// remaining time first. The signature is not verified here; this is only a hint.

function readToken() {
  try {
    return localStorage.getItem('token');
  } catch (e) {
    return null;
  }
}

/** Decoded JWT payload, or null for anything that is not a readable JWT. */
export function decodeToken(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch (e) {
    return null;
  }
}

/** Milliseconds until the stored token expires, or null when unknown. */
export function sessionRemainingMs() {
  const payload = decodeToken(readToken());
  if (!payload || typeof payload.exp !== 'number') return null;
  return payload.exp * 1000 - Date.now();
}

/** True when the session is known to end within `minMs`. */
export function sessionEndsWithin(minMs) {
  const remaining = sessionRemainingMs();
  return remaining !== null && remaining < minMs;
}

export const SESSION_ENDING_MESSAGE =
  'Vaše přihlášení brzy vyprší a nahrávání by se nedokončilo. Odhlaste se, znovu se přihlaste a potom soubor nahrajte.';
